import { MAX_SUBTITLE_LENGTH } from '../../../constants/form';
import * as Form from '../../Form';
import { BasicDetailsSectionBase } from '../../dapp-form/sections/BasicDetailsSectionBase';
import { PreviewUploadsField } from '../components/PreviewUploadsField';
import { PackageNameField } from '../components/PackageNameField';
import type {
  FormState,
  NewDappInputChangeEvent,
  SingleFileFieldName,
} from '../types';

interface BasicDetailsSectionProps {
  formData: FormState;
  previewDimensions?: { width: number; height: number } | null;
  packageNameError: string | null;
  isCheckingPackageName: boolean;
  showPackageNameSpinner: boolean;
  packageNameValid: boolean;
  onInputChange: (event: NewDappInputChangeEvent) => void;
  onPreviewFileChange: (index: number, file: File | null) => void;
  onAddPreviewSlot: () => void;
  onRemovePreviewSlot: (index: number) => void;
  onSingleFileChange: (
    fieldName: SingleFileFieldName,
    file: File | null,
  ) => void;
}

export function BasicDetailsSection({
  formData,
  previewDimensions,
  packageNameError,
  isCheckingPackageName,
  showPackageNameSpinner,
  packageNameValid,
  onInputChange,
  onPreviewFileChange,
  onAddPreviewSlot,
  onRemovePreviewSlot,
  onSingleFileChange,
}: BasicDetailsSectionProps) {
  return (
    <BasicDetailsSectionBase
      dappName={formData.dappName}
      subtitle={formData.subtitle}
      description={formData.description}
      subtitleHintText={`Maximum ${MAX_SUBTITLE_LENGTH} characters`}
      packageNameField={
        <PackageNameField
          value={formData.packageName}
          error={packageNameError}
          isChecking={isCheckingPackageName}
          showSpinner={showPackageNameSpinner}
          isValid={packageNameValid}
          onChange={onInputChange}
        />
      }
      uploadFields={
        <div className="self-stretch flex flex-col md:flex-row gap-6">
          <Form.ImageUploadInput
            name="dappIcon"
            label="dApp Icon"
            description="The dApp icon appears in lists, detail page, and throughout the Seeker device. (Required)"
            dimensions="512x512px"
            value={formData.dappIcon}
            onChange={(file: File | null) =>
              onSingleFileChange('dappIcon', file)
            }
            buttonType="upload"
            buttonClassName="bg-teal-600 text-white rounded-lg"
            placeholderClassName="w-24 h-24"
          />
          <Form.ImageUploadInput
            name="banner"
            label="Banner"
            description="This appears at the top of the detail page, behind the dApp icon. (Required)"
            dimensions="1200x600px"
            value={formData.banner}
            onChange={(file: File | null) => onSingleFileChange('banner', file)}
            buttonType="add"
            buttonClassName="text-white"
            placeholderClassName="w-44 h-24"
          />
        </div>
      }
      previewUploadsField={
        <PreviewUploadsField
          dappPreviews={formData.dappPreviews}
          previewDimensions={previewDimensions}
          onPreviewFileChange={onPreviewFileChange}
          onAddPreviewSlot={onAddPreviewSlot}
          onRemovePreviewSlot={onRemovePreviewSlot}
        />
      }
    />
  );
}
